import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import _ from 'lodash'
import cx from 'classnames'

import Signal from '../Signal'

import { LOCALE_PREFIX_SIGNALS } from '../../../Blocks/SyntheticIndicators/constants'

import './style.scss'

export default class Section extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        sectionId: PropTypes.string.isRequired,
        signals: PropTypes.array,
        scrollTo: PropTypes.func.isRequired,
        scrollRefs: PropTypes.object.isRequired,
        // dispaches
        toggleSignalDetail: PropTypes.func.isRequired,
        openLinkagesById: PropTypes.func,
        setupDistraintsById: PropTypes.func,
        signalsOpenCiaNews: PropTypes.func.isRequired,
    }

    render() {
        const {
            module,
            block,
            customData,
            signals,
            mainId,
            sectionId,
            scrollTo,
            scrollRefs,
            // dispatches
            toggleSignalDetail,
            openLinkagesById,
            setupDistraintsById,
            signalsOpenCiaNews,
        } = this.props

        return (
            <div className={cx('signals-section', _.isEmpty(signals) && 'inactive')}>
                <div className={cx('section-title', sectionId)}>
                    <FormattedMessage id={`${LOCALE_PREFIX_SIGNALS}.syntheticIndicators.${sectionId}SectionTitle`} />
                </div>
                {!_.isEmpty(signals) &&
                    _.map(
                        signals,
                        (
                            {
                                type,
                                heading,
                                detailEntities,
                                detail,
                                valueNumber,
                                valueText,
                                properties,
                                valueDate = null,
                            },
                            key
                        ) => (
                            <Signal
                                module={module}
                                block={block}
                                customData={customData}
                                key={`signal-${key}`}
                                type={type}
                                label={heading}
                                detailEntities={detailEntities}
                                detail={detail}
                                ownershipPercentage={valueText}
                                ownershipDepth={valueNumber}
                                mainId={mainId}
                                properties={properties}
                                scrollTo={scrollTo}
                                scrollRefs={scrollRefs}
                                // dispatches
                                toggleSignalDetail={toggleSignalDetail}
                                openLinkagesById={openLinkagesById}
                                setupDistraintsById={setupDistraintsById}
                                signalsOpenCiaNews={signalsOpenCiaNews}
                                dateFinancialStatement={valueDate}
                            />
                        )
                    )}
            </div>
        )
    }
}
